import "./PlanetTraveler.css";

/**
 * 행성 꼭대기에 서 있는 작은 여행자. 읽은 책이 TRAVELER_UNLOCK 권을 넘으면 찾아온다.
 *
 * 무루가 직접 그린 인물이다. 어느 동화의 그림을 옮기거나 그 이름을 빌리지
 * 않는다 — 원작 그림의 저작권이 끝났어도 인물과 이름은 따로 상표로
 * 관리되고 있어서다. 작은 사람 · 바람에 날리는 목도리 · 장미 한 송이면
 * 행성에 누가 산다는 느낌은 충분히 난다.
 *
 * 행성 요소 안에 넣는다. 행성이 둥실 떠오르는 움직임을 같이 타야 발이
 * 땅에서 떨어져 보이지 않는다.
 */
export default function PlanetTraveler({ size = "home" }) {
  return (
    <span className={`traveler traveler-${size}`} aria-hidden="true">
      <svg viewBox="0 0 60 50" width="100%" height="100%">
        {/* 장미 — 여행자 왼편 땅에 */}
        <g className="traveler-rose" transform="translate(7 1.2)">
          <path d="M9 50 C9 45 10 41 9.5 37" stroke="#7d9a6a" strokeWidth="1.1" fill="none" strokeLinecap="round" />
          <path d="M9.6 44 C7 43 6 41.5 6.2 40.2 C8 40.6 9.2 42 9.6 44Z" fill="#7d9a6a" />
          <circle cx="9.5" cy="35.4" r="2.9" fill="#c47a6b" />
          <path d="M7.4 35 C8.4 33.4 10.6 33.4 11.6 35" stroke="#8f4f44" strokeWidth=".7" fill="none" />
        </g>
        {/* 다리 */}
        <rect x="26.3" y="43" width="2.6" height="7" rx="1.2" fill="#b9ac95" />
        <rect x="31.1" y="43" width="2.6" height="7" rx="1.2" fill="#b9ac95" />
        {/* 긴 외투 */}
        <path d="M25.2 24.5 L34.8 24.5 L37.8 44.5 Q30 46.3 22.2 44.5 Z" fill="#efe6d6" />
        <path d="M30 26 L30 44.8" stroke="#d6cab5" strokeWidth=".8" />
        {/* 얼굴과 머리칼 */}
        <circle cx="30" cy="17.6" r="5.3" fill="#f5ecdd" />
        <path d="M24.7 17 C24.6 12.4 27.6 10.6 30.2 10.6 C33.2 10.6 35.6 12.6 35.3 16.6 C33.6 14.6 31.8 14 29.8 14.4 C27.8 14.8 26 15.8 24.7 17Z" fill="#c9a84c" />
        {/* 목도리 — 목에 두르고, 꼬리는 바람에 날린다 */}
        <path d="M24.8 22.6 Q30 25.6 35.2 22.6 L35.4 25 Q30 27.8 24.6 25 Z" fill="#c9a84c" />
        <path className="traveler-scarf" d="M34 23.6 C39 22.2 43 24.4 47.5 22 C51 20.2 53.5 21 56.5 18.8 C54.6 22.8 51.2 24.4 47.8 25.2 C43.4 26.4 39.4 26 34.6 25.8 Z" fill="#c9a84c" />
      </svg>
    </span>
  );
}
